<template>
    <div>
        <b-modal
            id="fog"
            ref="modal"
            :title="titlePopup"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit1()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form risk-factor-popup">
                    <div class="col-md-6">
                        <b-form-group
                            id="risk-factor-close"
                            label="CLOSE"
                            label-for="CLOSE"
                        >
                            <b-form-input
                                id="risk-factor-close-input"
                                v-model="formData.n_close"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="number"
                                autocomplete="no"
                                placeholder="Enter close"
                                name="close"
                                :class="{
                                    'is-invalid': errors.has('close'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="risk-factor-far"
                            label="FAR"
                            label-for="FAR"
                        >
                            <b-form-input
                                id="risk-factor-far-input"
                                v-model="formData.n_far"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="number"
                                autocomplete="no"
                                placeholder="Enter far"
                                name="far"
                                :class="{
                                    'is-invalid': errors.has('far'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            id="risk-factor-medium"
                            label="MEDIUM"
                            label-for="MEDIUM"
                        >
                            <b-form-input
                                id="risk-factor-medium-input"
                                v-model="formData.n_medium"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="number"
                                autocomplete="no"
                                placeholder="Enter medium"
                                name="medium"
                                :class="{
                                    'is-invalid': errors.has('medium'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="risk-factor-score"
                            label="SCORE"
                            label-for="SCORE"
                        >
                            <b-form-input
                                id="risk-factor-score-input"
                                v-model="formData.score"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="number"
                                autocomplete="no"
                                placeholder="Enter score"
                                name="score"
                                :class="{
                                    'is-invalid': errors.has('score'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <!-- <div class="col-md-12">
                        <b-form-group
                            id="risk-factor-override"
                            label="Override To"
                            label-for="Override To"
                        >
                            <b-form-select
                                id="risk-factor-override-input"
                                v-model="formData.overRideTo"
                                class="form-control"
                                :options="overrideToOptions"
                                name="overrideTo"
                                :class="{
                                    'is-invalid': errors.has('overrideTo'),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div> -->
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                        @click="onSubmit1()"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
        setWordScoreRecord: {
            type: Function,
            default: ()=>{}
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            abc: '123',
            overrideToOptions: [
                { value: null, text: 'Select Override To', disabled: true },
                { value: '', text: 'N/A' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanction Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titlePopup() {
            return (
                'Modify Risk Rating Score ' +
                (this.selectedItem && this.formData.factor ? this.formData.factor : '')
            )
        }, // End of titlePopup() method

        buttonLabel() {
            return 'Update'
        },
        highLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction'
                : 'High'
        },
        highPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction Scale'
                : 'High Scale'
        },
        lowLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium'
                : 'Low'
        },
        lowPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium Scale'
                : 'Low Scale'
        },
        mediumLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High'
                : 'Medium'
        },
        mediumPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High Scale'
                : 'Medium Scale'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            console.log('updated value score', value)
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                dataSegmentId: '',
                proximity_score_type: '',
                n_close: 0,
                n_far: 0,
                n_medium: 0,
                score: 0,
                search_type: 'PEP',
                interval: null,
            }
        }, // End of initializeFormData() method

        async getScoreDetails(event) {
            try {
                const ScoreApi = new resource(
                    `configurations/ProximityScore?type=Standard/PEP`
                )
                const CategoriApi = new resource(
                    `configurations/CategorieAdverse`
                )
                let data = await ScoreApi.get(this.formData.dataSegmentId)

                this.data1 = data.data.data
                let dataCategorie = await CategoriApi.get(
                    this.formData.dataSegmentId
                )

                this.Adverse_Check_items =
                    dataCategorie.data.data[0].AllCategorie

                this.Adverse_Check_items_most_used =
                    dataCategorie.data.data[0].MostCategorie
            } catch {
                console.log(error)
                this.$store.commit('setError', error)
                this.$store.commit('setLoading', false)
            }

            // this.tier = dataSegment.data.data.tier
            // this.subscription = dataSegment.data.data.subscription
            // if (this.subscription == 'unpaid') {
            //     this.counter = 0
            // } else {
            //     this.counter = dataSegment.data.data.counter
            // }

            // this.$store.commit('setDataSegmentList', this.dataSegmentList)
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */

        async onSubmit1() {
            const result = await this.$validator.validateAll()
            console.log('submit', this.formData)
            if (result) {
                try {
                    this.$store.commit('setLoading', true)
                    let params = {
                        search_type: 'PEP',
                        _id: this.formData._id,
                        dataSegmentId: this.formData.dataSegmentId,
                        type: this.formData.proximity_score_type,
                        n_close: parseInt(this.formData.n_close),
                        n_far: parseInt(this.formData.n_far),
                        n_medium: parseInt(this.formData.n_medium),
                        score: parseInt(this.formData.score),
                        id:this.formData.id
                    }
                    // cancel review process for this alert
                    let resourceApi = new resource(
                        'configurations/ProximityScore'
                    )
                    let { data } = await resourceApi.update(params._id, params)
                    this.setWordScoreRecord(this.formData)
                    this.$store.commit('setSuccess', data.message)
                    //     await this.$store.dispatch('onSubmit', this.formData)
                    this.$store.commit('setLoading', false)
                    this.$emit('click', this.abc)
                    this.$refs.modal.hide()
                    //     if (data) {
                    //         //          await this.$store.dispatch('onSubmit', this.formData)
                    //         this.$emit('click', this.abc)
                    //         this.$store.commit('setLoading', false)

                    //       await this.$store.dispatch('onSubmit', this.formData)
                    //         // await this.$store.commit('setAlertRecord', data.data)
                    //         // this.$store.commit('setRefreshProfile', true)

                    //         // this.interval = setInterval(
                    //         //     () => this.getNotifications(),
                    //         //     3000
                    //         // )
                    //         this.$store.commit('setSuccess', data.message)
                    //         this.$emit('click', this.abc)
                    //         this.$refs.modal.hide()
                    //     //    this.$router.go(0)
                    //  //   await this.getScoreDetails()

                    //     }

                    //   await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>
